import { CommonData } from "../../../datastructures/gamestate/gameData";
import {  TournamentRanking } from "../Interfaces_Tournament";
import { playerRank } from "./userInfo";

export class PostTournamentScreen
{   
    private parent:PIXI.Container;
    private lastResult:playerRank;
    private bestResult:playerRank;
    constructor(parent:PIXI.Container,fontStyle:PIXI.TextStyle,widthPortrait:number,height:number,activeGameData:CommonData)
    {

        this.parent=new PIXI.Container();
        parent.addChild(this.parent);
        this.lastResult=new playerRank(this.parent,fontStyle,widthPortrait,height,activeGameData.tournamentText);
        this.bestResult=new playerRank(this.parent,fontStyle,widthPortrait,height,activeGameData.tournamentText);

        this.bestResult.setPostScreenMode(1);
        this.lastResult.setPostScreenMode(0);

        // this.parent.x=400;
        this.parent.y=100
    }   

    public setVisbile=(bool:boolean)=>
    {   
        let alphaPar=bool?1:0;
        if(this.parent.alpha!=alphaPar)
        {
            this.parent.alpha=alphaPar;
        }
       
    }

    public setPostSceenData=(data:TournamentRanking):void=>
    {
        this.lastResult.setPlayerData(data.playerCurrentEntry,data.totalNumberOfEntries);
        this.bestResult.setPlayerData(data.playerTopEntry,data.totalNumberOfEntries);


        this.lastResult.setScore(data.playerCurrentEntry.score);
        this.bestResult.setScore(data.playerTopEntry.score);
        //set rebuy left 
        
        
    }

    public clearLastScore=():void=>
    {
        this.lastResult.setScore(0);
        
     }
}
